import { render, staticRenderFns } from "./AddStudentModal.vue?vue&type=template&id=6a73a4ea&scoped=true&"
import script from "./AddStudentModal.vue?vue&type=script&lang=js&"
export * from "./AddStudentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a73a4ea",
  null
  
)

export default component.exports